import React, { useState } from 'react';
import { Box, Grid, Paper, List, Divider } from '@material-ui/core';
import { ThreadItem } from './ThreadItem';
import { ThreadItemSkeleton } from './ThreadItemSkeleton';
import { Tags } from './Tags';
import { SearchBar } from './SearchBar';
import { Header } from './Header';
import { NotFoundQueryConversations } from 'src/modules/conversations/components/RecentThreads/notFoundQueryConversations';
import type { TConversationListFilter } from '../../constants/conversationStatus';
import {
    hasActiveAdvancedFilters,
    type TConversationAdvancedFilters,
} from '../../constants/conversationAdvancedFilters';

export const ThreadList = ({
    threads,
    activeThreadId,
    searchQuery,
    isLoading,
    advancedFilters,
    onSearchChange,
    onSearch,
    onAdvancedFiltersChange,
    listFilter,
    onListFilterChange,
    availableAreas = [],
    selectedArea = '',
    onAreaFilterChange,
    onThreadClick,
}: {
    threads: any[];
    activeThreadId?: string;
    searchQuery: string;
    isLoading?: boolean;
    advancedFilters: TConversationAdvancedFilters;
    onSearchChange: (value: string) => void;
    onSearch: () => void;
    onAdvancedFiltersChange: (filters: TConversationAdvancedFilters) => void;
    listFilter?: TConversationListFilter;
    onListFilterChange: (filter: TConversationListFilter) => void;
    availableAreas?: string[];
    selectedArea?: string;
    onAreaFilterChange?: (area: string) => void;
    onThreadClick?: (thread: any) => void;
}) => {
    const [tagsView, setTagsView] = useState<'none' | 'labels' | 'badges'>(
        'none'
    );

    const handleTagsViewChange = (view: 'none' | 'labels' | 'badges') =>
        setTagsView(view);

    const trimmedSearch = searchQuery.trim();
    const showEmptyResults =
        !isLoading &&
        threads.length === 0 &&
        (Boolean(trimmedSearch) || hasActiveAdvancedFilters(advancedFilters));

    return (
        <Box style={{ width: '25%' }}>
            <Paper
                style={{
                    height: '100%',
                    borderRadius: 0,
                }}
            >
                <Header
                    onListFilterChange={onListFilterChange}
                    listFilter={listFilter}
                    tagsView={tagsView}
                    onViewChange={handleTagsViewChange}
                    availableAreas={availableAreas}
                    selectedArea={selectedArea}
                    onAreaFilterChange={onAreaFilterChange}
                />
                <SearchBar
                    value={searchQuery}
                    onChange={onSearchChange}
                    onSearch={onSearch}
                    advancedFilters={advancedFilters}
                    onAdvancedFiltersChange={onAdvancedFiltersChange}
                />
                <Tags
                    advancedFilters={advancedFilters}
                    onAdvancedFiltersChange={onAdvancedFiltersChange}
                />
                <List
                    style={{
                        overflow: 'scroll',
                        maxHeight: 'calc(100vh - 300px)',
                    }}
                >
                    {showEmptyResults && (
                        <Box px={1}>
                            <NotFoundQueryConversations
                                query={trimmedSearch || undefined}
                            />
                        </Box>
                    )}
                    <Divider />
                    {isLoading
                        ? Array.from({ length: 6 }, (_, index) => (
                              <ThreadItemSkeleton key={index} />
                          ))
                        : threads.map((thread) => (
                              <>
                                  <ThreadItem
                                      key={thread._id}
                                      thread={thread}
                                      tagsView={tagsView}
                                      active={thread._id === activeThreadId}
                                      onClick={() => onThreadClick?.(thread)}
                                  />
                                  <Divider />
                              </>
                          ))}
                </List>
            </Paper>
        </Box>
    );
};
